webpackJsonp([2],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'WelcomePageModule',
    template: '#cmp-welcome',
    data: function data() {
        return {
            language: 'en-us',
            notifications: []
        };
    },

    computed: {
        showNotifications: function showNotifications() {
            $('[data-toggle=tooltip]').tooltip();
            return this.notifications.length > 0;
        }
    },
    methods: {
        getNotifications: function getNotifications() {
            var self = this;
            $.getJSON('/api/notifications').done(function (r) {
                self.language = r.language;
                if (r.notifications.length > 0) {
                    self.getNotificationContent(r.notifications);
                }
            });
        },
        getNotificationContent: function getNotificationContent(notifications) {
            var self = this;

            notifications.forEach(function (n) {
                var content = void 0;

                n.content.forEach(function (c) {
                    if (c.locale === self.language) {
                        content = c;
                    }
                });

                if (!content) {
                    n.content.forEach(function (c) {
                        if (c.locale === 'en-us') {
                            content = c;
                        }
                    });
                }

                if (!content) {
                    content = n.content[0];
                }

                content.guid = n.header.guid;
                //$('[data-toggle=tooltip]').tooltip();
                self.notifications.push(content);
            });
            $('[data-toggle=tooltip]').tooltip();
        },
        viewNotification: function viewNotification(n) {
            $('[data-toggle=tooltip]').tooltip();
            this.$router.push({ name: 'notificationDetails', params: { guid: n.guid } });
        }
    },
    created: function created() {
        var self = this;
        toggleRegisterLoginMsg(true);
        window.setTimeout(function () {
            self.getNotifications();
        }, 900);
    }
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_bundle__ = __webpack_require__(9);


__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('fwEmail', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /^[\w!\'.-]*[a-zA-Z0-9'_]@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/;
        return pattern.test(value);
    }
});

__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('validInput', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /^[^<>/`^]*$/;
        return pattern.test(value);
    }
});

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RequestAccessModule',
    template: '#cmp-request-access',
    data: function data() {
        return {
            firstName: '',
            surname: '',
            email: '',
            company: '',
            title: '',
            phone: '',
            country: '',
            comments: '',
            captcha: '',
            captchaImg: '/captcha/requestaccess',
            countries: [],
            showSuccess: false,
            showError: false,
            showForm: true,
            submitting: false,
            requestVerificationToken: '',
            NonZDC: false
        };
    },

    methods: {
        refreshCaptcha: function refreshCaptcha() {
            var self = this;
            var date = new Date();
            self.captchaImg = '/captcha/requestaccess?' + date.getTime();
        },
        requestAccess: function requestAccess(elem) {
            var self = this;

            self.$validator.validateAll().then(function (valid) {
                if (valid) {
                    self.submitting = true;
                    var requestAccess = {
                        firstName: self.firstName,
                        surname: self.surname,
                        email: self.email,
                        country: self.country,
                        title: self.title,
                        company: self.company,
                        phone: self.phone,
                        comments: self.comments,
                        captcha: self.captcha
                    };

                    $.ajax({
                        type: 'post',
                        url: '/api/account/requestaccess',
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(requestAccess),
                        headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
                    }).done(function (r) {
                        self.showSuccess = true;
                        self.showForm = false;
                    }).fail(function (r) {
                        var resp = r.responseJSON || {};
                        if (r.status === 400) {
                            if (resp.reason === 'captcha') {
                                self.$validator.errors.add('captcha', 'wrong', 'failed');
                            } else {
                                self.showError = true;
                            }
                        } else {
                            self.showError = true;
                        }

                        self.submitting = false;
                    });
                    return;
                }
            });
        },
        getCountries: function getCountries() {
            var self = this;
            $.getJSON('/api/countries').done(function (r) {
                self.countries = r;
            });
        },
        setRequestVerificationToken: function setRequestVerificationToken() {
            this.requestVerificationToken = $('input[name=__RequestVerificationToken]').val();
        }
    },
    created: function created() {
        this.setRequestVerificationToken();
        this.getCountries();
        toggleRegisterLoginMsg(false);
    }
});

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_bundle__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_debounce__ = __webpack_require__(108);



__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('pwd', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /(?=^.{8,20}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*/;
        return pattern.test(value);
    }
});

__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('fwUsername', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /^[a-zA-Z0-9\.\-_]{2,20}$/;
        return pattern.test(value);
    }
});

__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('fwEmail', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /^[\w!\'.-]*[a-zA-Z0-9'_]@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/;
        return pattern.test(value);
    }
});

__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('validInput', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /^[^<>/`^]*$/;
        return pattern.test(value);
    }
});

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RegistrationModule',
    template: '#cmp-registration',
    data: function data() {
        return {
            token: '',
            userSharedID: '',
            username: '',
            locale: 'en-us',
            password: '',
            passwordConfirm: '',
            email: '',
            salutation: 0,
            firstName: '',
            surname: '',
            title: '',
            phone: '',
            mobile: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            postCode: '',
            country: '',
            timeZone: 1,
            timeZones: [],
            salutations: [],
            locales: [],
            countries: [],
            step: 1,
            showSuccess: false,
            showError: false,
            showErrorToken: false,
            showForm: false,
            submitting: false,
            invalidEmail: undefined,
            requestVerificationToken: '',
            NonZDC: false,
            isEditable: true,
            showPasswordInValid: false,
            isTermsAccepted: false
        };
    },

    watch: {
        email: function email(n, o) {
            var self = this;
            if (n && /^[\w!\.-]*[a-zA-Z0-9_]@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/.test(n)) {
                self.validateEmail();
            }
        },
        username: function username(n, o) {
            if (n && /^[a-zA-Z0-9\.\-_]{2,20}$/.test(n)) {
                this.validateUsername();
            }
        }
    },
    computed: {},
    methods: {
        setStep: function setStep(step) {
            this.submitting = false;
            this.step = step;
            if (step == 2) {
                if (this.isTermsAccepted) {
                    this.submitting = false;
                } else {
                    this.submitting = true;
                }
            } else {
                this.submitting = false;
            }
            return false;
        },
        continueRegistration: function continueRegistration() {
            var self = this;
            self.showPasswordInValid = false;
            self.$validator.validateAll().then(function (valid) {
                var errors = self.$validator.errors.items.length;
                if (valid && errors === 0) {
                    self.setStep(2);
                }
            });
        },
        completeRegistration: function completeRegistration() {
            var self = this;
            self.showPasswordInValid = false;
            self.$validator.validateAll().then(function (valid) {
                if (valid) {
                    self.submitting = true;

                    var data = {
                        token: self.token,
                        userSharedID: self.userSharedID,
                        username: self.username,
                        locale: self.locale,
                        password: self.password,
                        passwordConfirm: self.passwordConfirm,
                        email: self.email,
                        salutation: self.salutation,
                        firstName: self.firstName,
                        surname: self.surname,
                        title: self.title,
                        phone: self.phone,
                        mobile: self.mobile,
                        address1: self.address1,
                        address2: self.address2,
                        city: self.city,
                        state: self.state,
                        postalCode: self.postCode,
                        country: self.country,
                        timeZone: self.timeZone,
                        isEditable: self.isEditable,
                        isTermsAccepted: self.isTermsAccepted
                    };

                    $.ajax({
                        type: 'post',
                        url: '/api/invite/' + self.token,
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(data),
                        headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
                    }).done(function (r) {
                        self.showSuccess = true;
                        self.showForm = false;
                    }).fail(function (r) {
                        if (r.status === 400) {
                            var resp = r.responseJSON;
                            if (resp.validInvite) {
                                if (!resp.validUsername) {
                                    self.$validator.errors.add('username', 'wrong', 'taken');
                                }

                                if (!resp.validEmail) {
                                    self.$validator.errors.add('email', 'wrong', 'taken');
                                }

                                self.setStep(1);
                            } else {
                                if (resp.passwordInValid) {
                                    self.showPasswordInValid = true;
                                    self.setStep(1);
                                } else if (!resp.validInvite && !resp.valid) {
                                    self.showError = true;
                                    self.showForm = false;
                                } else {
                                    self.showErrorToken = true;
                                    self.showForm = false;
                                }
                            }
                        } else {
                            self.showError = true;
                        }
                    });
                }

                return valid;
            });
        },
        validateToken: function validateToken() {
            var self = this;

            $.ajax({
                type: 'post',
                url: '/api/invite/validate',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(self.token),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            }).done(function (r) {
                if (r.valid) {
                    self.showForm = true;
                    self.getForm();
                    self.getInvite();
                } else {
                    self.showErrorToken = true;
                }
            }).fail(function () {
                self.showError = true;
                self.submitting = false;
            });
        },

        validateUsername: Object(__WEBPACK_IMPORTED_MODULE_1__utils_debounce__["a" /* default */])(function () {
            var self = this;
            var data = {
                username: self.username,
                userSharedID: self.userSharedID
            };

            self.submitting = true;
            self.$validator.errors.remove('username');

            $.ajax({
                type: 'post',
                url: '/api/account/validation/username',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            }).done(function (r) {
                if (r.valid) {} else {
                    self.$validator.errors.add('username', 'wrong', 'taken');
                }
                self.submitting = false;
            }).fail(function () {
                self.showError = true;
                self.submitting = false;
            });
        }, 1000),

        validateEmail: Object(__WEBPACK_IMPORTED_MODULE_1__utils_debounce__["a" /* default */])(function () {
            var self = this;
            var data = {
                email: self.email,
                userSharedID: self.userSharedID
            };

            self.submitting = true;
            self.$validator.errors.remove('email');

            $.ajax({
                type: 'post',
                url: '/api/account/validation/email',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            }).done(function (r) {
                if (r.valid) {} else {
                    self.$validator.errors.add('email', 'wrong', 'taken');
                }
                self.submitting = false;
            }).fail(function () {
                self.showError = true;
                self.submitting = false;
            });
        }, 1000),

        getForm: function getForm() {
            var self = this;

            $.getJSON('/api/invite/form').done(function (r) {
                self.countries = r.countries;
                self.locales = r.locales;
                self.salutations = r.salutations;
                self.timeZones = r.timeZones;
            }).fail(function () {
                self.showError = true;
                self.submitting = false;
            });
        },
        getInvite: function getInvite() {
            var self = this;

            $.getJSON('/api/invite/' + self.token).done(function (r) {
                if (r.valid) {
                    self.showForm = true;
                    self.userSharedID = r.data.sharedID;
                    self.username = r.data.username;
                    self.firstName = r.data.firstName;
                    self.surname = r.data.surname;
                    self.salutation = r.data.salutation;
                    self.title = r.data.title;
                    self.username = r.data.username;
                    self.email = r.data.email;
                    self.locale = r.data.locale;
                    self.timeZone = r.data.timeZone;
                    self.phone = r.data.phone;
                    self.mobile = r.data.mobile;
                    self.address1 = r.data.address1;
                    self.address2 = r.data.address2;
                    self.city = r.data.city;
                    self.state = r.data.state;
                    self.postCode = r.data.postalCode;
                    self.country = r.data.country;
                    self.isEditable = r.data.isEditable;
                    self.isTermsAccepted = !self.isEditable;
                } else {
                    self.showForm = false;
                    self.showErrorToken = true;
                }
            }).fail(function () {
                self.showError = true;
                self.submitting = false;
            });
        },
        setRequestVerificationToken: function setRequestVerificationToken() {
            this.requestVerificationToken = $('input[name=__RequestVerificationToken]').val();
        },
        checkedTermsConditions: function checkedTermsConditions() {
            this.submitting = false;
            this.isTermsAccepted = !this.isTermsAccepted;
            if (this.isTermsAccepted) {
                this.submitting = false;
            } else {
                this.submitting = true;
            }
        }
    },
    created: function created() {
        var self = this;
        self.token = self.$route.params.token;
        self.setRequestVerificationToken();
        self.validateToken();
        toggleRegisterLoginMsg(false);
    }
});

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
function debounce(fn, delay) {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
}

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_bundle__ = __webpack_require__(9);


__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('fwEmail', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /^[\w!\'.-]*[a-zA-Z0-9'_]@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/;
        return pattern.test(value);
    }
});

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RequestPasswordResetModule',
    template: '#cmp-request-password-reset',
    data: function data() {
        return {
            email: '',
            captcha: '',
            captchaImg: '/captcha/passwordresetrequest',
            showSuccess: false,
            showError: false,
            showForm: true,
            submitting: false,
            requestVerificationToken: '',
            NonZDC: false,
            errorMsg: '',
            showServerError: false
        };
    },

    methods: {
        refreshCaptcha: function refreshCaptcha() {
            var self = this;
            var date = new Date();
            self.captchaImg = '/captcha/passwordresetrequest?' + date.getTime();
        },
        requestPasswordReset: function requestPasswordReset() {
            var self = this;

            self.$validator.validateAll().then(function (valid) {
                if (valid) {
                    self.submitting = true;

                    var data = {
                        email: self.email,
                        captcha: self.captcha
                    };
                    $.ajax({
                        type: 'post',
                        url: '/api/password/requestreset',
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(data),
                        headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
                    }).done(function (r) {
                        if (r.success == false) {
                            self.showServerError = true;
                            self.errorMsg = r.msg;
                            self.submitting = false;
                            self.showForm = true;
                            self.showSuccess = false;
                            self.refreshCaptcha();
                            self.captcha = '';
                        } else {
                            if (r.msg == 'B2CRedirect') {
                                self.showSuccess = false;
                                window.location.href = r.b2Curl;
                            } else {
                                self.showSuccess = true;
                                self.showForm = false;
                            }
                        }
                    }).fail(function (r) {
                        if (r.status === 400) {
                            if (!r.realPersonCheck) {
                                self.$validator.errors.add('captcha', 'wrong', 'failed');
                            }
                        } else {
                            self.showError = true;
                        }

                        self.submitting = false;
                    });

                    return;
                }
            });
        },
        setRequestVerificationToken: function setRequestVerificationToken() {
            this.requestVerificationToken = $('input[name=__RequestVerificationToken]').val();
        }
    },
    created: function created() {
        this.setRequestVerificationToken();
        toggleRegisterLoginMsg(false);
    }
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_bundle__ = __webpack_require__(9);


__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"].Validator.extend('pwd', {
    getMessage: function getMessage(field) {
        return '*';
    },
    validate: function validate(value) {
        var pattern = /(?=^.{8,20}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*/;
        return pattern.test(value);
    }
});

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PasswordResetModule',
    template: '#cmp-password-reset',
    data: function data() {
        return {
            token: null,
            password: '',
            passwordConfirm: '',
            showSuccess: false,
            showError: false,
            showErrorToken: false,
            showForm: false,
            submitting: false,
            requestVerificationToken: '',
            NonZDC: false,
            showPasswordInValid: false
        };
    },

    methods: {
        resetPassword: function resetPassword() {
            var self = this;
            self.showPasswordInValid = false;
            self.$validator.validateAll().then(function (valid) {
                if (valid) {
                    self.submitting = true;

                    var passwordReset = {
                        token: self.token,
                        password: self.passwordConfirm
                    };

                    $.ajax({
                        type: 'post',
                        url: '/api/password/reset',
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(passwordReset),
                        headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
                    }).done(function (r) {
                        if (r.valid) {
                            self.showForm = false;
                            self.showSuccess = true;
                        } else {
                            if (r.passwordInValid) {
                                self.showPasswordInValid = true;
                                self.submitting = false;
                            } else {
                                self.showErrorToken = true;
                            }
                        }
                    }).fail(function () {
                        self.showError = true;
                        self.submitting = false;
                    });
                }
            });
        },
        resetPasswordB2C: function resetPasswordB2C() {
            var self = this;

            $.ajax({
                type: 'post',
                url: '/api/password/PasswordResetB2C',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(''),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            }).done(function (r) {
                if (r.msg == 'B2CRedirect') {
                    self.showSuccess = false;
                    window.location.href = r.b2Curl;
                }
            }).fail(function () {
                self.showError = true;
                self.submitting = false;
            });
        },
        validateToken: function validateToken() {
            var self = this;

            $.ajax({
                type: 'post',
                url: '/api/password/validate',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(self.token),
                headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
            }).done(function (r) {
                if (r.valid) {
                    self.showForm = true;
                } else {
                    self.showErrorToken = true;
                }
            }).fail(function () {
                self.showError = true;
                self.submitting = false;
            });
        },
        setRequestVerificationToken: function setRequestVerificationToken() {
            this.requestVerificationToken = $('input[name=__RequestVerificationToken]').val();
        }
    },
    created: function created() {
        var self = this;
        self.token = self.$route.params.token;
        self.setRequestVerificationToken();
        self.validateToken();
        toggleRegisterLoginMsg(false);
    }
});

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'NotificationDetailsAnon',
    template: '#cmp-notification-anon',
    data: function data() {
        return {
            guid: '',
            language: 'en-us',
            notification: null,
            showContent: false,
            showError: false,
            showError404: false,
            submitting: true
        };
    },

    methods: {
        getNotification: function getNotification() {
            var self = this;
            $.getJSON('/api/notifications/' + self.guid).done(function (r) {
                self.submitting = false;
                self.showContent = true;
                self.language = r.language;
                self.getNotificationContent(r.notification.content);
            }).fail(function (e) {
                if (e.status === 404) {
                    self.showError404 = true;
                } else {
                    self.showError = true;
                }
                self.submitting = false;
            });
        },
        getNotificationContent: function getNotificationContent(notifications) {
            var self = this;
            var content = void 0;

            notifications.forEach(function (c) {
                if (c.locale === self.language) {
                    content = c;
                }
            });

            if (!content) {
                notifications.forEach(function (c) {
                    if (c.locale === 'en-us') {
                        content = c;
                    }
                });
            }

            if (!content) {
                content = notifications[0];
            }

            self.notification = content;
        }
    },
    created: function created() {
        this.guid = this.$route.params.guid;
        this.getNotification();
    }
});

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(96);


/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_bundle__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Welcome__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RequestAccess__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Registration__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RequestPasswordReset__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordReset__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NotificationAnon__ = __webpack_require__(111);


__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["Vue"].use(__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VueRouter"]);
__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["Vue"].use(__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VeeValidate"], { events: '' });
__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["Vue"].use(__WEBPACK_IMPORTED_MODULE_0__vue_bundle__["Notifications"]);








var routes = [{
    name: 'default',
    path: '/',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_1__components_Welcome__["a" /* default */]
    }
}, {
    name: 'requestAccess',
    path: '/requestaccess',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_2__components_RequestAccess__["a" /* default */]
    }
}, {
    name: 'registrationInvalid',
    path: '/registration',
    redirect: '/'
}, {
    name: 'registration',
    path: '/registration/:token',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_3__components_Registration__["a" /* default */]
    }
}, {
    name: 'requestPasswordReset',
    path: '/requestpasswordreset',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_4__components_RequestPasswordReset__["a" /* default */]
    }
}, {
    name: 'passwordResetInvalid',
    path: '/passwordreset',
    redirect: '/'
}, {
    name: 'passwordReset',
    path: '/passwordreset/:token',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_5__components_PasswordReset__["a" /* default */]
    }
}, {
    name: 'notificationDetails',
    path: '/notifications/:guid',
    components: {
        default: __WEBPACK_IMPORTED_MODULE_6__components_NotificationAnon__["a" /* default */]
    }
}, { path: '/home', redirect: '/' }];

var router = new __WEBPACK_IMPORTED_MODULE_0__vue_bundle__["VueRouter"]({
    routes: routes
});

new __WEBPACK_IMPORTED_MODULE_0__vue_bundle__["Vue"]({
    router: router,
    methods: {
        hashChangeHandler: function hashChangeHandler() {
            var target = window.location.hash;
            this.$router.push(target.substring(1, target.length));
        }
    },
    mounted: function mounted() {
        // fix for IE 11
        if (!!window.MSInputMethodContext && !!document.documentMode) {
            window.addEventListener('hashchange', this.hashChangeHandler);
        }
    },
    destroyed: function destroyed() {
        // fix for IE 11
        if (!!window.MSInputMethodContext && !!document.documentMode) {
            window.removeEventListener('hashchange', this.hashChangeHandler);
        }
    }

}).$mount("#app");

/***/ })

},[95]);


// WEBPACK FOOTER //
// public.js